(function () {
  if (window.__bnexoEverartLightboxInit) return;
  window.__bnexoEverartLightboxInit = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var openState = null;

  function getImageFromTrigger(trigger) {
    if (trigger.tagName === 'IMG') return trigger;
    return trigger.querySelector('img');
  }

  function getBestSrc(trigger, sourceImg) {
    if (trigger && trigger.dataset && trigger.dataset.zoomSrc) {
      return trigger.dataset.zoomSrc;
    }
    if (sourceImg && sourceImg.dataset && sourceImg.dataset.zoomSrc) {
      return sourceImg.dataset.zoomSrc;
    }
    return (sourceImg && (sourceImg.currentSrc || sourceImg.src)) || '';
  }

  function getTargetSize(naturalWidth, naturalHeight) {
    var maxW = Math.min(window.innerWidth * 0.92, 1100);
    var maxH = window.innerHeight * 0.88;
    var ratio = naturalWidth / naturalHeight || 1;
    var finalW = maxW;
    var finalH = finalW / ratio;

    if (finalH > maxH) {
      finalH = maxH;
      finalW = finalH * ratio;
    }

    return {
      width: finalW,
      height: finalH,
      left: (window.innerWidth - finalW) / 2,
      top: (window.innerHeight - finalH) / 2,
    };
  }

  function applyFrame(img, frame) {
    img.style.width = frame.width + 'px';
    img.style.height = frame.height + 'px';
    img.style.left = frame.left + 'px';
    img.style.top = frame.top + 'px';
  }

  function getLinkedGallery(trigger) {
    var gallery = trigger.closest('bnexo-everart-gallery');
    return gallery && typeof gallery.pause === 'function' ? gallery : null;
  }

  function resumeGallery() {
    if (openState && openState.gallery && typeof openState.gallery.scheduleResume === 'function') {
      openState.gallery.scheduleResume();
    }
  }

  function openLightbox(trigger) {
    var sourceImg = getImageFromTrigger(trigger);
    if (!sourceImg || openState) return;

    var rect = sourceImg.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return;

    var src = getBestSrc(trigger, sourceImg);
    var alt = sourceImg.alt || '';

    var linkedGallery = getLinkedGallery(trigger);
    if (linkedGallery) linkedGallery.pause(true);

    var overlay = document.createElement('div');
    overlay.className = 'bnexo-everart-lightbox';
    overlay.innerHTML =
      '<button type="button" class="bnexo-everart-lightbox__backdrop" data-ea-lightbox-close aria-label="Fermer"></button>' +
      '<button type="button" class="bnexo-everart-lightbox__close" data-ea-lightbox-close aria-label="Fermer">&times;</button>' +
      '<img class="bnexo-everart-lightbox__img" src="' + src + '" alt="">';

    var flyImg = overlay.querySelector('.bnexo-everart-lightbox__img');
    flyImg.alt = alt;

    document.body.appendChild(overlay);
    document.body.classList.add('bnexo-everart-lightbox-open');

    openState = {
      overlay: overlay,
      sourceImg: sourceImg,
      flyImg: flyImg,
      gallery: linkedGallery,
    };

    applyFrame(flyImg, {
      width: rect.width,
      height: rect.height,
      left: rect.left,
      top: rect.top,
    });

    flyImg.style.objectFit = 'cover';
    flyImg.style.borderRadius = window.getComputedStyle(sourceImg).borderRadius || '14px';

    var animateIn = function () {
      var target = getTargetSize(flyImg.naturalWidth || rect.width, flyImg.naturalHeight || rect.height);

      overlay.classList.add('is-open');

      if (reducedMotion) {
        applyFrame(flyImg, target);
        flyImg.style.objectFit = 'contain';
        flyImg.style.borderRadius = '12px';
        return;
      }

      flyImg.style.transition =
        'left 0.45s cubic-bezier(0.22, 1, 0.36, 1), top 0.45s cubic-bezier(0.22, 1, 0.36, 1), width 0.45s cubic-bezier(0.22, 1, 0.36, 1), height 0.45s cubic-bezier(0.22, 1, 0.36, 1), border-radius 0.45s ease';
      requestAnimationFrame(function () {
        applyFrame(flyImg, target);
        flyImg.style.objectFit = 'contain';
        flyImg.style.borderRadius = '12px';
      });
    };

    if (flyImg.complete && flyImg.naturalWidth) {
      animateIn();
    } else {
      flyImg.addEventListener('load', animateIn, { once: true });
    }
  }

  function closeLightbox() {
    if (!openState) return;

    var overlay = openState.overlay;
    var flyImg = openState.flyImg;
    var sourceImg = openState.sourceImg;
    var rect = sourceImg.getBoundingClientRect();

    overlay.classList.remove('is-open');

    if (reducedMotion) {
      overlay.remove();
      document.body.classList.remove('bnexo-everart-lightbox-open');
      resumeGallery();
      openState = null;
      return;
    }

    flyImg.style.transition =
      'left 0.35s cubic-bezier(0.4, 0, 0.2, 1), top 0.35s cubic-bezier(0.4, 0, 0.2, 1), width 0.35s cubic-bezier(0.4, 0, 0.2, 1), height 0.35s cubic-bezier(0.4, 0, 0.2, 1), border-radius 0.35s ease';
    applyFrame(flyImg, {
      width: Math.max(rect.width, 1),
      height: Math.max(rect.height, 1),
      left: rect.left,
      top: rect.top,
    });
    flyImg.style.objectFit = 'cover';
    flyImg.style.borderRadius = window.getComputedStyle(sourceImg).borderRadius || '14px';

    window.setTimeout(function () {
      overlay.remove();
      document.body.classList.remove('bnexo-everart-lightbox-open');
      resumeGallery();
      openState = null;
    }, 360);
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-ea-zoom]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        openLightbox(trigger);
        return;
      }

      if (openState && event.target.closest('[data-ea-lightbox-close]')) {
        event.preventDefault();
        closeLightbox();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openState) {
      closeLightbox();
    }
  });
})();
